<div class="card">
  <div class="card-header-panel">
    <h4>News</h4>
  </div>

  <otcx-error-or-loading [errorWrapper]="newsLoader">
    @if (newsLoader.data$ | async; as news) {
      <otcx-news-list
        [newsList]="news.items"
        [collapsedThreshold]="5"
        showAllLabel="Letzte 2 Wochen anzeigen">
      </otcx-news-list>
    }
  </otcx-error-or-loading>
</div>
